import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { Image } from "@learningblocks/shared-components";

/**
 * Icon:
 *   - Icon for all Question Components
 */
export function Icon(props) {
  const className = `${style.icon} ${props.className}`;
  return (
    <div className={className}>
      <Image src={props.icon} alt="tooltip-icon" />
    </div>
  );
}

Icon.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * Icon shows in the tool tip
   */
  icon: PropTypes.string,
};

Icon.defaultProps = {
  icon: "",
  className: "",
};
